export const mixinTable = {
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    handleSearch() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // pageSize 改变时会触发
    handleSizeChange(pageSize) {
      this.table.params.count = pageSize;
      this.table.params.page = 1;
      this.getTable();
    },
    //页面改变时触发
    handleCurrentChange(page) {
      this.table.params.page = page;
      this.getTable();
    },
    // 字段转义
    toStr(data, key) {
      return data[key] || ''
    },
    getParamsJob() {
      this.$http.post("/common/param/job", { type: 'date_type|education|work_age|job_type|nature|scale|welfare' }).then(res => {
        if (res.code == 1) {
          let info = res.data;
          this.education_ = info.education
          this.work_age_ = info.work_age
        }
      })
    },
    // 获取专业类型
    getMajor() {
      this.$http
        .get("/common/college/getMajor", { params: { page: 1, count: 10000 } })
        .then((res) => {
          if (res.code == 1) {
            this.majorArr = res.data.list;
            let str = { id: 0, name: "不限" };
            this.majorArr.unshift(str);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList_ = res.data.list;
          }
        });
    },
    //拿全部的代理
    getAgentList() {
      this.$http
        .get("/admin/agent/list", { params: {page:1,count:9999} })
        .then((res) => {
          if (res.code === 1) {
            this.agentList_ = res.data.list;
          } 
        });
    },
    // 获取岗位类别
    getCategory() {
      this.$http.get("common/param/category", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.categoryArr = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getSchoolOption() {
      this.$http.get("/admin/college/list", { params: { count: 10000, page: 1 } }).then(res =>{
        if(res.code == 1) {
          this.schoolOption = res.data.list;
        }
      })
    },
    getSchoolOptionQuery(query) {
      this.$http.get("/admin/college/list", { params: { count: 10000, page: 1 ,name:query} }).then(res =>{
        if(res.code == 1) {
          this.schoolOption = res.data.list;
        }
      })
    },
    getJobList() {
      this.$http.get("/admin/job/list", { params: { count: 10000, page: 1 } }).then(res =>{
        if(res.code == 1) {
          this.jobOption_ = res.data.list;
        }
      })
    },
  }
}